import React from 'react'
import './components/cssStyle/LoadingSpin.css'




const LoadingSpin = () => {
  return (

    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );

}

export default LoadingSpin